import { create } from 'zustand'
import { devtools } from 'utils/devtools'

type RefractionDebugState = {
  overrideActive: boolean
  setOverrideActive: (value: boolean) => void
}

export const useRefractionDebugStore = create<RefractionDebugState>()(
  devtools(
    (set) => ({
      overrideActive: false,
      setOverrideActive: (value) => set({ overrideActive: value }),
    }),
    { name: 'refraction-debug' }
  )
)
